import clsx from 'clsx';
import { ComponentSize, TextColor } from '../../../../types';
import { getTagColorFromHex } from '../../../../utils';
import { Badge } from '../../Badge';
import { Icon, Icons } from '../../Icons';
import { Typography } from '../../Typography';
import { getInputClasses } from '../Input.utils';
import { MULTI_INPUT_SIZE, MULTI_INPUT_SIZE_TO_TYPOGRAPHY_TYPE } from './MultiInput.constants';
import { MultiInputProps } from './MultiInput.types';

const BADGE_MAX_WIDTH = 100;

const MultiInput = ({
  className,
  disabled,
  focused,
  endElement,
  error,
  placeholder,
  size = ComponentSize.SMALL,
  value,
  width,
  wrap = false,
}: MultiInputProps) => {
  return (
    <div className={clsx(!width && 'w-full', className)} style={{ width }}>
      <div
        className={clsx(
          'input input-bordered flex h-auto w-full items-center gap-2 py-[min(4px)]',
          MULTI_INPUT_SIZE[size],
          getInputClasses({ disabled, error, focused })
        )}
      >
        <div className="min-w-0 flex-1">
          <div className={clsx('flex items-center gap-2', wrap ? 'flex-wrap' : 'overflow-x-auto')}>
            {!value.length && (
              <Typography color={TextColor.TERTIARY} type={MULTI_INPUT_SIZE_TO_TYPOGRAPHY_TYPE[size]}>
                {placeholder}
              </Typography>
            )}
            {value.map((item, index) => {
              const color = getTagColorFromHex(item.color);
              return (
                <Badge
                  key={index}
                  className="flex-shrink-0"
                  color={color}
                  endElement={
                    item.onDelete && (
                      <Icons color={color} icon={Icon.CLOSE} size={ComponentSize.X_SMALL} onClick={item.onDelete} />
                    )
                  }
                  label={item.label}
                  size={size}
                  maxWidth={BADGE_MAX_WIDTH}
                />
              );
            })}
          </div>
        </div>
        {endElement && <div className="flex-shrink-0">{endElement}</div>}
      </div>
    </div>
  );
};

export default MultiInput;
